<!--
    描述：字典管理页面
    时间：2020-04-27
    Created by zwh
-->
<template>
	<div class="w-table-layout" :class="{'w-table-page': searchObj.listType == 0}">
		<transition name="fade"
					mode="out-in">
			<!-- 列表 -->
			<div class="list-wrap w-table-content"
				 ref="tableContent"
				 key="list">
				<!--
                <vxe-table
                  ref="objTable"
                  row-id="id"
                  :height="tableObj.tableH"
                  :loading="tableObj.loading"
                  :data="tableObj.tableData"
                  :tree-config="{children: 'children'}"
                >
                -->
                <vxe-table
                    ref="objTable"
                    border
                    highlight-hover-row
                    highlight-current-row
                    highlight-hover-column
                    highlight-current-column
                    row-id="id"
                    height="auto"
                    :data="tableObj.tableData"
                    :tree-config="{children: 'children'}"
                >
                  <vxe-table-column field="value" title="字典编号" min-width="150" tree-node>
                  </vxe-table-column>
                  <vxe-table-column field="sname" title="字典名称" min-width="150">
                  </vxe-table-column>
                  <vxe-table-column field="sort" title="排序" width="80" align="center"></vxe-table-column>
                  <vxe-table-column field="parentName" title="父级字典" min-width="150"></vxe-table-column>
				  <vxe-table-column field="remarks" title="备注" show-overflow min-width="150"></vxe-table-column>
                  <vxe-table-column field="updateUserName" title="更新人" min-width="100"></vxe-table-column>
                  <vxe-table-column field="updateDate" title="更新时间" min-width="100"></vxe-table-column>
                  <vxe-table-column field="type" title="操作" align="center" width="100">
                    <template v-slot="{ row }">
                        <el-button size="mini" icon="el-icon-circle-plus" title="新增" type="text"
                            v-if="roleBtns.includes('dict_add')"
                            @click="doClick(row,'add')">
                        </el-button>
                        <el-button size="mini" icon="el-icon-edit" title="编辑" type="text"
                           v-if="roleBtns.includes('dict_edit')"
                           @click="doClick(row,'edit')">
                        </el-button>
                        <el-button v-if="(!row.children || row.children.length === 0) && roleBtns.includes('dict_delete')"
                                                   size="mini"
                                                   icon="el-icon-delete"
                                                   title="删除"
                                                   type="text"
                                                   @click="doClick(row,'delete')"></el-button>
                    </template>
                  </vxe-table-column>
                </vxe-table>
			</div>
		</transition>

		<!-- 底部分页 -->
		<div v-if="searchObj.listType==0" class="w-table-pager">
		    <!-- :loading="loading" -->
            <vxe-pager
              :current-page="tableObj.currentPage"
              :page-size="tableObj.pageSize"
              :total="tableObj.total"
              :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
			  align="center"
              @page-change="handleCurrentChange"
			  class="footer-container"
            >
            </vxe-pager>
		</div>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :close-on-click-modal="false"
				   @closed="handleClose">

			<!-- 弹窗组件 -->
			<addDialog v-if="dialogObj.visible"
					   :transObj="transObj"
					   ref="addDialog"
					   @on-success="onSuccess"></addDialog>

			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.type !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getTreeTablePageList, getTreeTableList, deleteById } from '@/api/modules/dict.js'
import addDialog from './add_dialog'
export default {
	components: { addDialog },
	props: {},
	data() {
		return {
			transObj: {
				id: '',
				parentId: '',
				parentName: '',
				type: ''
			},
			searchObj: {
			    listType : 0,  //0-所有查询条件为空，1-列表带查询条件
			    sname : '',
			},
			tableObj: {
				loading: false,
				pageSize: 10,
				currentPage: 1,
				total: 0,
				tableH: 0,
				originTableData: [],
				tableData: [],
				pageList: [10, 20, 50, 100] // 显示条数数组
			},
			btnLoading: false,
			dialogObj: {
				title: '',
				visible: false,
				width: '650px',
				mode: 'add'
			}
		}
	},
	created() {
		this.getTablePageList()
		this.getTableList()
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.tableContent.offsetHeight
			}, 100)
		})
	},
	methods: {
		searchTablePageList(searchObj) {
		    let that = this
			this.searchObj = searchObj
			let sname = this.searchObj.sname
			if(sname != ''){        //前台查询列表信息（不分页），不走后台接口
			    that.searchObj.listType = 1
			    that.queryTableList(sname)
			}else {                 //条件为空，查询后台列表接口（分页），获取字典列表信息
			    this.tableObj.currentPage = 1
			    this.tableObj.pageSize = 10
			    this.getTablePageList()
			}
		},

		//前台查询列表信息，不走后台接口
		queryTableList(sname){
		    let that = this
		    const XEUtils = require('xe-utils')
            let options = { children: 'children' }
            let searchProps = ['sname']
            this.tableObj.tableData = XEUtils.searchTree(that.tableObj.oriTableData, item => searchProps.some(key => XEUtils.toString(item[key]).indexOf(sname) > -1), options)

            // 搜索之后默认展开所有子节点
            this.$nextTick(() => {
              this.$refs.objTable.setAllTreeExpansion(true)
            })
		},

		//分页：字典列表信息
		getTablePageList() {
			let that = this
			that.searchObj.listType = 0
			let param = {}
			param.current = this.tableObj.currentPage
			param.size = this.tableObj.pageSize
			getTreeTablePageList(param).then(res => {
				if (res.operationCode == 1) {
					that.tableObj.tableData = res.data.records
					this.tableObj.total = parseInt(res.data.total)
				}
			})
		},

		//不分页：字典列表信息
		getTableList(){
		    let that = this
            let param = {}
            getTreeTableList(param).then(res => {
                if (res.operationCode == 1) {
                    that.tableObj.oriTableData = res.data
                }
            })
		},

		//新增、修改、删除等操作按钮点击事件
		doClick(obj, type) {
			let that = this
			if (type === 'add' || type === 'addGroup') {
				that.transObj.mode = 'add'
				that.transObj.id = ''
				that.transObj.type = type
				if (obj != '') {
					that.transObj.parentId = obj.id
					that.transObj.parentName = obj.sname
				} else {
					that.transObj.parentId = '0'
					that.transObj.parentName = ''
				}
				this.dialogObj.title = '新增字典'
				this.dialogObj.visible = true
			} else if (type === 'edit') {
				that.transObj.mode = 'edit'
				if (obj.parentId == 0) that.transObj.type = 'editGroup'
				else that.transObj.type = 'edit'
				this.transObj.id = obj.id
				this.transObj.parentId = ''
				this.transObj.parentName = ''
				this.dialogObj.title = '编辑字典'
				this.dialogObj.visible = true
			} else if (type === 'delete') {
				that.transObj.mode = 'delete'
				this.delete(obj)
			}
		},

		// 确认删除弹窗
		delete(obj) {
			let that = this
			this.$confirm('确认删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let param = { id: obj.id }
				deleteById(param).then(res => {
					if (res.operationCode == 1) {
						that.$message({ message: '删除成功', type: 'success' })
						that.getTablePageList()
					} else {
						that.$message({ message: res.msg, type: 'error' })
					}
				})
			})
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.tableObj.pageSize = val
			this.getTablePageList()
		},

		// 切换当前页码
		handleCurrentChange({ currentPage, pageSize }) {
			this.tableObj.currentPage = currentPage
            this.tableObj.pageSize = pageSize
			this.getTablePageList()
		},

		// 弹窗确认保存
		doSave() {
			this.$refs.addDialog.doSave()
		},

		// 保存成功回调
		onSuccess() {
			this.dialogObj.visible = false
			this.getTablePageList()
			this.$emit('on-reset')
		},
		handleClose() {},
    },
    computed: {
        ...mapState('menu', {
            roleBtns: state => state.roleBtns
        })
    }
}
</script>

<style scoped lang="less">
.w-table-pager {
	.footer-container {
		height: 100%;
	}
}
</style>